import React from 'react';
import styles from './Contest.module.css';

const Contest = () => (
  <div className={styles.Contest} data-testid="Contest">
    Contest Component
  </div>
);

export default Contest;
